
import React from 'react';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface PageNavigationProps {
  pageNumber: number;
  totalPages: number;
  isNextButtonDisabled: boolean;
  isSubmitting: boolean;
  onPrevPage: () => void;
  onNextClick: () => void;
  isStudentAbsent?: boolean;
  isReviewMode?: boolean;
}

const PageNavigation: React.FC<PageNavigationProps> = ({
  pageNumber,
  totalPages,
  isNextButtonDisabled,
  isSubmitting,
  onPrevPage,
  onNextClick,
  isStudentAbsent,
  isReviewMode,
}) => {
  const { t } = useTranslation();
  // Determine button text based on current conditions
  const getButtonText = () => {
    if (pageNumber === 2 && isStudentAbsent) {
      return isSubmitting ? t('form.submitting') : t('form.submit');
    }
    
    if (isReviewMode) {
      return isSubmitting ? t('form.submitting') : t('form.submit');
    }
    
    if (pageNumber === totalPages - 1) { // Last page before review
      return t('form.reviewBtn');
    }
    
    return t('form.next');
  };

  return (
    <div className="flex justify-between mt-8 mb-10">
      {(pageNumber > 1 || isReviewMode) && (
        <Button 
          type="button"
          variant="outline"
          onClick={onPrevPage}
          className="px-6"
        >
          {t('form.back')}
        </Button>
      )}
      <div className={`${pageNumber > 1 || isReviewMode ? 'ml-auto' : ''}`}>
        <Button 
          type="button"
          onClick={onNextClick}
          disabled={isNextButtonDisabled || isSubmitting}
          className="bg-form-blue hover:bg-form-light-blue px-8"
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};

export default PageNavigation;
